// Central source of truth for Domestic Home Services company details.
// Do not display any date earlier than 29 July 2024 anywhere on the platform.

export const COMPANY = {
  name: 'Domestic Home Services Limited',
  shortName: 'Domestic Home Services',
  tagline: 'Everyday home protection, done right',
  companyNumber: '17368184',
  incorporatedOn: '2024-07-29', // 29 July 2024 (never show dates earlier than this)
  registeredOffice: {
    line1: '128 City Road',
    line2: '',
    city: 'London',
    country: 'United Kingdom',
    postcode: 'EC1V 2NX',
    full: '128 City Road, London, United Kingdom, EC1V 2NX',
    short: '128 City Road, London EC1V 2NX',
  },
  phone: '+44 (0)113 548 7557',
  phoneShort: '0113 548 7557',
  phoneTel: '01135487557',
  email: 'hello@domestichomeservices.com',
  supportEmail: 'hello@domestichomeservices.com',
  website: 'www.domestichomeservices.com',
  bank: {
    accountName: 'DOMESTIC HOME SERVICES LIMITED',
    sortCode: '04-19-19',
    accountNumber: '00786003',
  },
};

// Format a date, guarding against pre-incorporation values.
export const safeDate = (input) => {
  const min = new Date(COMPANY.incorporatedOn);
  const d = input ? new Date(input) : new Date();
  return (isNaN(d.getTime()) || d < min) ? min : d;
};

export const formatDate = (input, opts) => {
  const d = safeDate(input);
  return d.toLocaleDateString('en-GB', opts || { day: '2-digit', month: 'short', year: 'numeric' });
};
